import { deflate } from 'pako';
import httpStatus from 'http-status-codes';

import Config from '../../config';
import fetch from '../../utils/fetchService';
import { handleErrors } from '../../utils/requestHelpers';

import saveAs from '../saveAs';

import { FILE_EXTENSION } from '@common/xlsxExport/xlsxExport.constants';

const downloadXlsxFile = async (filename, sheets) => {
  const filenameWithExtension = `${filename}.${FILE_EXTENSION}`;

  return await fetch(
    Config.endpoints.XLSX_EXPORT
      .replace(/:filename/, encodeURIComponent(filenameWithExtension)),
    {
      method: 'POST',
      body: deflate(JSON.stringify(sheets)),
      headers: {
        'Content-Encoding': 'deflate',
      },
    })
    .then(handleErrors({ errorMessage: 'Generating Excel failed' }))
    .then(res => {
      if (res.status === httpStatus.OK) {
        return res.blob();
      }
    })
    .then(blob => saveAs({ blob, filenameWithExtension }));
};

export default downloadXlsxFile;
